export default __webpack_public_path__ + "static/media/Resume3-page-001.16cf76e1.jpg";